import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';
import type { PaneQuery } from '../../shared/contracts';

interface FilterState {
  query: PaneQuery;
  setQuery: (query: PaneQuery) => void;
}

/** Exported so tests (and the provider) can supply a value directly. */
export const FilterContext = createContext<FilterState | null>(null);

const INERT: FilterState = { query: {}, setQuery: () => undefined };

/** Holds the active period/filter selection, shared across every pane on the page. */
export function FilterProvider({ children }: { children: ReactNode }) {
  const [query, setQuery] = useState<PaneQuery>({});
  const value = useMemo(() => ({ query, setQuery }), [query]);
  return <FilterContext.Provider value={value}>{children}</FilterContext.Provider>;
}

/** Current pane query (period + filters). Returns an inert default outside a provider. */
export function usePaneQuery(): FilterState {
  return useContext(FilterContext) ?? INERT;
}
